<p-button
  (click)="openBugReport()"
  [severity]="'primary'"
  [rounded]="true"
  class="text-2xl"
  [size]="'small'"
>
  <i class="fa-light fa-bug fa-2x"></i>

</p-button>




